var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.viewport.left.hover",modifiers:{"viewport":true,"left":true,"hover":true}}],class:['pill', 'pill-'+_vm.situationClass],attrs:{"title":_vm.textTooltip.toUpperCase()}},[_vm._v(" "+_vm._s(_vm.situation.toUpperCase())+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }